import React, { useState } from 'react'
import {
  Grid,
  Card,
  Box,
  Typography,
  makeStyles,
  Checkbox,
  Button,
  CardMedia,
  IconButton,
  Stack,
  Tooltip,
} from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { PictureAsPdf } from '@material-ui/icons'
import { DialogAnimate } from 'src/components/animate'
import axios from 'axios'
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'
import { Icon } from '@iconify/react'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined'
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined'
import Modal from './ProjectModel'
import Label from 'src/components/Label'
import filePdfIcon from '@iconify/icons-mdi/file-pdf';

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
    cursor: 'pointer',
    display: 'flex',
    borderRadius: '6px',
    backgroundColor: '#172e34',
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    height: '143px',
    overflow: 'hidden',
  },
  attachmentIcon: {
    marginRight: theme.spacing(1),
  },
  delete: {
    m: 2,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  checkbox: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  checkboxContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
  },
  approvedContainer: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(3),
    maxWidth: 768,
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  //   gridContainer: {
  //     height: 'auto',
  //   },
  card: {
    borderRadius: theme.spacing(1),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    cursor: 'pointer',
  },
  media: {
    height: 0,
    paddingTop: '100%',
    width: '100%',
    objectFit: 'fill',
  },
  gridContainer: {
    height: 'auto',
    overflowY: 'auto',
    paddingRight: '0.5rem',
    '&::-webkit-scrollbar': {
      width: '0.75rem',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(110, 108, 108, 0.32)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(110, 108, 108, 0.32)',
      borderRadius: '4px',
    },
  },
}))

export default function DesignProjectFileAttach({
  details,
  data,
  setFetchData,
  refresh,
  setRefresh,
  projectId,
  designOrder,
  secTab,
  isAllAttachments,
  isRefer
}) {
  console.log('detailsdetailsdetails',details)
  const classes = useStyles()
  const theme = useTheme()
  let user = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions = user?.exploded_permissions
  const { enqueueSnackbar } = useSnackbar()
  const [open, setOpen] = useState(false)
  const [selectedAttachment, setSelectedAttachment] = useState(null)
  const [checkedItems, setCheckedItems] = useState([])
  const [openImageModal, setOpenImageModal] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(null)

  const handleCheckboxChange = (id) => {
    setCheckedItems((prevState) => {
      const isPresent = prevState.includes(id)
      const updatedState = isPresent
        ? prevState.filter((item) => item !== id)
        : [...prevState, id]
      return updatedState
    })
  }

  //   const handleUpdateDesign = () => {

  //     const data = { id: id, status: 0, num: 4 }
  //     axios
  //       .post(`${REST_API_END_POINT}request/update-designs`, data)
  //       .then((res) => {
  //       })
  //   }

  const handleDelete = async () => {
    try {
      let apiUrl = ''
      if (designOrder) {
        apiUrl = `design-order-job/delete-attachment`
      } else {
        apiUrl = `project-task/delete-project-attachment`
      }
      const res = await axios.post(`${REST_API_END_POINT}${apiUrl}`, {
        // const res = await axios.post(`${REST_API_END_POINT}project-task/delete-project-attachment`,{
        userId: user.user_id,
        attachments: checkedItems,
        projectId,
      })
      if (res.data.status === 1) {
        const attachmentsToUpdate = data.filter(
          (attachment) =>
            checkedItems.includes(attachment.ID) &&
            attachment.not_approved_image === 1,
        )

        if (attachmentsToUpdate.length > 0) {
          const updatePromises = attachmentsToUpdate.map((attachment) =>
            axios.post(`${REST_API_END_POINT}request/update-designs`, {
              requestId: attachment.request_id,
              userId: user.user_id,
              id: attachment.ID,
              status: 0,
              num: 4,
            }),
          )

          // Wait for all updates to complete
          await Promise.all(updatePromises)
        }
        enqueueSnackbar(res.data.message, { variant: 'success' })
        setRefresh(!refresh)
        setCheckedItems([])
        if (designOrder) {
          setFetchData(true)
        }
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' })
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleAttachmentClick = (attachment) => {
    setSelectedAttachment(attachment)
    setOpen(true)
  }
  const imageDesigns = data?.filter(
    (item) =>
      item.file_type?.startsWith('image/') ||
      item.file_type === 'img' ||
      item.file_type === 'image',
  )

  // Define valid image extensions
  const imageExtensions = [
    'jpg',
    'jpeg',
    'png',
    'gif',
    'avif',
    'bmp',
    'tiff',
    'webp',
    'heif',
    // "other"
  ]
  const videoExtensions = ['mp4', 'avi', 'mkv', 'mov', 'wmv']
  const documentExtensions = ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'txt']

  const handleImageClick = (index) => {
    setCurrentImageIndex(index)
    setOpenImageModal(true)
  }

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : prevIndex,
    )
  }

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex,
    )
  }
  console.log('return======data', data)
  return (
    <>
      {checkedItems.length > 0 && (
        <Box
          sx={{
            mb: 3,
            position:'absolute',
            top:3,
            right:3,
            display: 'flex',
            alignItems:'center',
            justifyContent: 'flex-end',
            gap: 2,
            m: 2.5,
          }}
        >
          <Typography variant="subtitle1">
            {checkedItems.length} selected
          </Typography>
          <Button
            disabled={
              designOrder
                ? !explodedPermissions?.some((permission) =>
                    ['Delete Design from Design Order Job'].includes(
                      permission,
                    ),
                  )
                : false
            }
            onClick={() => handleDelete()}
            className={classes.delete}
            size="small"
            variant="outlined"
            sx={{
              alignItems:'center',
              justifyContent: 'center',
            }}
          >
            <Icon icon={trash2Outline} width={24} height={24} /> Delete
          </Button>
        </Box>
      )}

      {data?.length > 0 ? (
        <Grid className={classes.gridContainer} container spacing={2} pb={4}>
          {data?.map((attachment, index) => {
            const fileType = attachment.file_type?.toLowerCase() // Normalize case
            const fileExtension = attachment.extension?.toLowerCase() // Normalize case
            const isImage =
              fileType?.startsWith('image/') ||
              fileType === 'img' ||
              fileType === 'image' ||
              imageExtensions.includes(fileExtension)
            console.log('isImage', isImage)
            const isDocument =
              fileType === 'application/pdf' ||
              documentExtensions.includes(fileExtension) ||
              fileType?.includes('document')
            console.log('isDocument', isDocument)
            console.log('isImageattachment', attachment)
            return (
              <Grid key={attachment.id} item xs={12} sm={4} pb={4}>
                {isImage ? (
                  <Card className={classes.card}>
                    {/* <Box className={classes.approvedContainer}>
                      {attachment.approved === 1 ?(
                        <Label
                          variant={'filled'}
                          color={'success'}
                          style={{ color: 'white', height: 20, width: 100 }}
                        >
                          {'Approved'}
                        </Label>                       
                      ): 
                      attachment.reason ? (
                        <Tooltip title={attachment.reason}>
                          <Label
                            variant={'filled'}
                            color={'error'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Rejected'}
                          </Label>
                        </Tooltip>
                      ):null}
                    </Box> */}
                    <CardMedia
                      className={classes.media}
                      image={attachment.file_url}
                      title={`Image ${attachment.file_url}`}
                      onClick={(e) => {
                        e.preventDefault()
                        handleImageClick(
                          imageDesigns.findIndex(
                            (img) => img.file_url === attachment.file_url,
                          ),
                        )
                      }}
                    />
                    {/* {isAllAttachments || (details?.send_client_app_req == 1 && attachment?.isDesign == 1) || attachment?.approved == 1 ? ( */}
                    {isRefer || isAllAttachments || (details?.send_client_app_req == 1 && attachment?.isDesign == 1) ? (
                      ''
                    ) : (
                      <Box className={classes.checkboxContainer}>
                        <Checkbox
                          sx={{
                            cursor: 'pointer',
                            // color: 'primary',
                            backgroundColor: theme.palette.grey.A700
                          }}
                          checked={
                            checkedItems.includes(attachment.ID) ? true : false
                          }
                          onChange={() => handleCheckboxChange(attachment.ID)}
                          color="primary"
                        />
                      </Box>
                    )}
                  </Card>
                ) : isDocument ? (
                  <Box
                    className={classes.attachmentBox}
                    display="flex"
                    alignItems="center"
                  >
                    {/* <Box className={classes.approvedContainer}>
                      {attachment.approved === 1 ?(
                        <Label
                          variant={'filled'}
                          color={'success'}
                          style={{ color: 'white', height: 20, width: 100 }}
                        >
                          {'Approved'}
                        </Label>                       
                      ): 
                      attachment.reason ? (
                        <Tooltip title={attachment.reason}>
                          <Label
                            variant={'filled'}
                            color={'error'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Rejected'}
                          </Label>
                        </Tooltip>
                      ):null}
                    </Box> */}
                    <Box
                      onClick={() => handleAttachmentClick(attachment)}
                      style={{
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {/* <PictureAsPdf className={classes.attachmentIcon} />
                                {designOrder ? '' : <Typography>{attachment.name}</Typography> } */}
                      {attachment?.not_approved_image === 1 ? (
                        <img
                          src={attachment.file_url}
                          alt={attachment.name}
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: 4,
                          }}
                        />
                      ) : (
                        <>

                          <Tooltip title="View PDF">
                                                    <IconButton
                                                      onClick={() => {
                                                       handleAttachmentClick(attachment)
                                                      }}
                                                      aria-label="open pdf"
                                                        sx={{ position:'absolute', 
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                       zIndex: 200,color:theme.palette.error.main, backgroundColor:theme.palette.text.primary }} 
                                                    >
                                                      <PictureAsPdf
                                                        style={{ fontSize: 50, color: 'red' }}
                                                      />{' '}
                                                      {/* ✅ Increased size */}
                                                    </IconButton>
                                                  </Tooltip>
                          {/* <PictureAsPdf className={classes.attachmentIcon} /> */}
                            <iframe
                            src={attachment.file_url}
                            title={attachment.name}
                            style={{ width: '240px', height: '240px' }}
                            frameBorder="0"
                          />
                          {designOrder ? (
                            ''
                          ) : (
                            <Typography>{attachment.name}</Typography>
                          )}
                        </>
                      )}
                    </Box>
                    {/* {isAllAttachments || (details?.send_client_app_req == 1 && attachment?.isDesign == 1) || attachment?.approved == 1 ? ( */}
                    {isRefer || isAllAttachments || (details?.send_client_app_req == 1 && attachment?.isDesign == 1) ? (
                      ''
                    ) : (
                      <Box className={classes.checkboxContainer}>
                        <Checkbox
                          sx={{
                            cursor: 'pointer',
                            // color: 'black',
                            backgroundColor: theme.palette.grey.A700
                          }}
                          checked={
                            checkedItems.includes(attachment.ID) ? true : false
                          }
                          onChange={() => handleCheckboxChange(attachment.ID)}
                          color="primary"
                        />
                      </Box>
                    )}
                  </Box>
                ) : null}
              </Grid>
            )
          })}
        </Grid>
      ) : (
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          py={15}
        >
          No {isRefer ? 'References' : isAllAttachments ? 'Attachments' : secTab == 'Designs' ? 'designs' : 'files'} found
        </Box>
      )}

      <Modal
        width={1000}
        open={openImageModal}
        handleClose={() => {
          setOpenImageModal(false)
        }}
        modalTitle={isRefer ? 'References' : isAllAttachments ? 'Attachments' : secTab == 'Designs' ? 'Designs' : 'Files'}
      >
        <div
          style={{
            position: 'relative',
            width: '100%',
            height: '100%',
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <IconButton
            onClick={handlePrevious}
            disabled={currentImageIndex === 0}
            sx={{
              opacity: currentImageIndex === 0 ? 0.3 : 1,
              pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
            }}
          >
            <Icon
              icon={arrowLeftOutlined}
              width={24}
              height={24}
              color="#006097"
            />
          </IconButton>

          <Box
            component={'div'}
            style={{
              width: '500px',
              height: '500px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 8,
              overflow: 'hidden',
            }}
          >
            <img
              src={imageDesigns[currentImageIndex]?.file_url}
              alt={`Image ${currentImageIndex + 1}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 8,
              }}
            />
          </Box>
          <IconButton
            onClick={handleNext}
            disabled={currentImageIndex === imageDesigns.length - 1}
            sx={{
              opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
              pointerEvents:
                currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
            }}
          >
            <Icon
              icon={arrowRightOutlined}
              width={24}
              height={24}
              color="#006097"
            />
          </IconButton>
        </div>
      </Modal>

      <DialogAnimate open={open} onClose={() => setOpen(false)}>
        <Card className={classes.dialogContent}>
          {selectedAttachment &&
            (selectedAttachment.not_approved_image === 1 ? (
              <Box
                component="div"
                style={{
                  width: '500px',
                  height: '500px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 8,
                  overflow: 'hidden',
                }}
              >
                <img
                  src={selectedAttachment.file_url}
                  alt={selectedAttachment.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: 8,
                  }}
                />
              </Box>
            ) : (
              <div
                style={{
                    maxWidth:'768px',
                    width:'100%',
                    display: 'flex',
                    flexDirection:'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                >
                <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        onClick={() => window.open(selectedAttachment.file_url, '_blank')}
                        disabled={!selectedAttachment.file_url}
                        startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                        sx={{
                        fontSize:'14px'
                        }}
                    >
                        View PDF
                    </Button>
                </div>
              <embed
                src={selectedAttachment.file_url}
                type="application/pdf"
                width="100%"
                height="500px"
              />
              </div>
            ))}
        </Card>
      </DialogAnimate>
    </>
  )
}
